<script setup lang="ts">
import { ref } from 'vue';
import { Stack, Typography } from './core';

type Props = {
  label?: string;
  openByDefault?: boolean;
}

const props = defineProps<Props>();

const isOpen = ref(props.openByDefault);
</script>
<template>
  <Stack :gap="4" class="w-full">
    <div class="flex items-center gap-2 w-full">
      <span class="grow-0 cursor-pointer pi" :class="isOpen ? 'pi-minus' : 'pi-plus'" @click="isOpen = !isOpen" />
      <Typography variant="small-subtitle" class="cursor-pointer" @click="isOpen = !isOpen">
        {{ isOpen ? 'Collapse' : 'Show' }} {{ props.label ?? '' }}
      </Typography>
      <div class="grow h-[1px] bg-[var(--p-form-field-border-color)]" />
    </div>
    <transition name="fade-slide">
      <div v-show="isOpen">
        <slot />
      </div>
    </transition>
  </Stack>
</template>
<style scoped>
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.5s ease;
}
.fade-slide-enter-from, .fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.fade-slide-enter-to, .fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
